'use client'
import { FormEvent, useState } from 'react'
import { signIn } from 'next-auth/react'
import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { AuthErrorType } from '@/app/utils/authError'

export default function Page() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [firstLogin, setFirstLogin] = useState(false)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    if (firstLogin && newPassword !== confirmation) {
      setError('新しいパスワードが一致しません。')
      return
    }
    setBusy(true)
    try {
      const result = await signIn('credentials', {
        username: username.trim(), password, newPassword: firstLogin ? newPassword : '', redirect: false
      })
      if (result?.ok && !result.error) {
        window.location.href = '/'
        return
      }
      if (result?.error === AuthErrorType.NEW_PASSWORD_REQUIRED) {
        setFirstLogin(true)
      } else if (result?.error === AuthErrorType.PASSWORD_POLICY) {
        setError('パスワードの条件を満たしていません。大文字・小文字・数字・記号を含めて再入力してください。')
      } else {
        setError('ログインできませんでした。メールアドレス・パスワード・利用権限を運営にご確認ください。')
      }
    } catch {
      setError('接続できませんでした。時間をおいて再度お試しください。')
    } finally {
      setBusy(false)
    }
  }

  return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#EAEBF0', p: 2 }}>
    <Card sx={{ width: '100%', maxWidth: 460 }}><CardContent sx={{ p: 4 }}>
      <Stack component='form' onSubmit={submit} spacing={3}>
        <Typography variant='h5' component='h1'>FaveU Dashboard</Typography>
        {firstLogin && <Alert severity='info'>初回ログインです。これから使うパスワードを設定してください。</Alert>}
        {error && <Alert severity='error'>{error}</Alert>}
        <TextField required label='メールアドレス' type='email' autoComplete='username' value={username}
          onChange={e => { setUsername(e.target.value); setFirstLogin(false) }} disabled={busy} />
        <TextField required label={firstLogin ? '仮パスワード' : 'パスワード'} type='password' autoComplete='current-password'
          value={password} onChange={e => setPassword(e.target.value)} disabled={busy} />
        {firstLogin && <>
          <TextField required label='新しいパスワード' type='password' autoComplete='new-password' value={newPassword}
            onChange={e => setNewPassword(e.target.value)} disabled={busy} inputProps={{ minLength: 8 }} />
          <TextField required label='新しいパスワード（確認）' type='password' autoComplete='new-password' value={confirmation}
            onChange={e => setConfirmation(e.target.value)} disabled={busy} />
        </>}
        <Button type='submit' variant='contained' disabled={busy}>{busy ? '確認中…' : firstLogin ? 'パスワードを設定してログイン' : 'ログイン'}</Button>
        <Typography variant='body2' color='text.secondary'>アカウントは運営が発行します。利用をご希望の方は運営担当者へご連絡ください。</Typography>
      </Stack>
    </CardContent></Card>
  </Box>
}
